const PH = '\uE000';

export function escapeCommentHtml(text) {
  return String(text == null ? '' : text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function formatCommentText(raw) {
  let s = escapeCommentHtml(raw);
  const codes = [];
  s = s.replace(/`([^`\n]+)`/g, (m, c) => {
    codes.push(c);
    return PH + (codes.length - 1) + PH;
  });
  s = s.replace(/\[([^\]\n]+)\]\((https?:\/\/[^\s)"'`<]+)\)/g,
    '<a href="$2" target="_blank" rel="noopener nofollow">$1</a>');
  s = s.replace(/(^|[^"'>=/])(https?:\/\/[^\s<"'`]+)/g,
    '$1<a href="$2" target="_blank" rel="noopener nofollow">$2</a>');
  s = s.replace(/\*\*([^*\n]+)\*\*/g, '<strong>$1</strong>');
  s = s.replace(/(^|[\s(])\*(\S(?:[^*\n]*\S)?)\*(?=$|[\s).,!?])/g, '$1<em>$2</em>');
  s = s.replace(/(^|[\s(])_(\S(?:[^_\n]*\S)?)_(?=$|[\s).,!?])/g, '$1<em>$2</em>');
  s = s.replace(/~~([^~\n]+)~~/g, '<del>$1</del>');
  s = s.replace(/(^|\s)@([a-zA-Z0-9_-]{2,40})/g, '$1<a href="/u/$2" class="comment-mention">@$2</a>');
  s = s.replace(/(^|\s)#([a-zA-Z0-9_]{2,40})/g, '$1<a href="/gallery?q=%23$2" class="comment-hashtag">#$2</a>');
  s = s.replace(/\n/g, '<br>');
  s = s.replace(new RegExp(PH + '(\\d+)' + PH, 'g'), (m, i) => `<code>${codes[+i]}</code>`);
  return s;
}

export function relativeTime(value) {
  if (!value) return '';
  const t = new Date(value).getTime();
  if (!t) return '';
  const diff = Math.floor((Date.now() - t) / 1000);
  if (diff < 0) return 'now';
  if (diff < 60) return 'now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d`;
  return new Date(value).toLocaleDateString();
}
